export const /** ConfirmDialogSG Styles */ confirmDialogSGStyles = {
    textButton: {
        padding: '0.625rem 0.75rem',
        textTransform: 'none',
        margin: '0 0 0 0.5rem',
    },
};
